export const checkIndexedDB = async (): Promise<boolean> => {
  try {
    // Try to open a test database
    const testDb = await new Promise((resolve, reject) => {
      const request = indexedDB.open("test-db");
      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
    // Clean up the test database
    (testDb as IDBDatabase).close();
    await new Promise((resolve, reject) => {
      const request = indexedDB.deleteDatabase("test-db");
      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(undefined);
    });
    return true;
  } catch {
    return false;
  }
};
